import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      name: '',
      salesChannelId: 0,
      sentTo: '',
      emailSubject: '',
      emailFrom: '',
      emailBcc: '',
      emailHeadline: '',
      emailBody: '',
      source: '',
      template: '',
      emailReplyTo: '',
      logoImage: '',
      products: [],
      featuredProduct: 0,
      emailSubjectPromo:'',
        emailHeadlinePromo: '',
        emailBodyPromo: '',
        email2Subject:'',
        email2Headline: '',
        email2Body: '',
        email2SubjectPromo:'',
        email2HeadlinePromo: '',
        email2BodyPromo: '',
        email3Subject:'',
        email3Headline: '',
        email3Body: '',
        email3SubjectPromo:'',
        email3HeadlinePromo: '',
        email3BodyPromo: '',
        email4Subject:'',
        email4Headline: '',
        email4Body: '',
        email4SubjectPromo:'',
        email4HeadlinePromo: '',
        email4BodyPromo: '',
    },
  ],
  campaign: {
    name: '',
    salesChannelId: 0,
    sentTo: '',
    emailSubject: '',
    emailFrom: '',
    emailBcc: '',
    emailHeadline: '',
    emailBody: '',
    source: '',
    template: '',
    emailReplyTo: '',
    logoImage: '',
    products: [],
    featuredProduct: 0,
    emailSubjectPromo:'',
        emailHeadlinePromo: '',
        emailBodyPromo: '',
        email2Subject:'',
        email2Headline: '',
        email2Body: '',
        email2SubjectPromo:'',
        email2HeadlinePromo: '',
        email2BodyPromo: '',
        email3Subject:'',
        email3Headline: '',
        email3Body: '',
        email3SubjectPromo:'',
        email3HeadlinePromo: '',
        email3BodyPromo: '',
        email4Subject:'',
        email4Headline: '',
        email4Body: '',
        email4SubjectPromo:'',
        email4HeadlinePromo: '',
        email4BodyPromo: '',
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/campaigns?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function campaigns(state = initialState, action) {
  switch (action.type) {
    case types.CAMPAIGNS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.CAMPAIGNS_FETCH_ERROR:
    case types.CAMPAIGN_FETCH_ERROR:
    case types.CAMPAIGN_EDIT_ERROR:
    case types.CAMPAIGN_SET_ERROR:
    case types.CAMPAIGN_DISABLE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.CAMPAIGN_FETCH_SUCCESS:
    case types.CAMPAIGN_EDIT_SUCCESS:
    case types.CAMPAIGN_SET_SUCCESS:
      return assign({}, state, {
        campaign: action.res,
      });
    case types.CAMPAIGN_DISABLE_SUCCESS:
      return assign({}, state, {
        campaignDisabled: action.res.ok,
      });
    case types.CAMPAIGN_DELETE_SUCCESS:
      return assign({}, state, {
        campaignDelete: action.res.ok,
      });
    case types.CAMPAIGNS_CLEAR_ERRORS:
    case types.CAMPAIGN_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default campaigns;



// WEBPACK FOOTER //
// ./src/reducers/campaigns.js